import { render, staticRenderFns } from "./task-skeleton.vue?vue&type=template&id=39cbd935&scoped=true&"
import script from "./task-skeleton.vue?vue&type=script&lang=ts&"
export * from "./task-skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./task-skeleton.vue?vue&type=style&index=0&id=39cbd935&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbd935",
  null
  
)

export default component.exports